import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[heightInput]'
})
export class HeightInputDirective {
    private allowedKeys: string[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];

    // Define acceptable height range
    private minHeight = 50;   // cm
    private maxHeight = 300;  // cm

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (this.allowedKeys.includes(event.key)) {
            return;
        }

        // Prevent non-digit entries
        if (!/^\d$/.test(event.key)) {
            event.preventDefault();
        }
    }

    @HostListener('input', ['$event'])
    onInput(event: Event) {
        const input = event.target as HTMLInputElement;
        let value = input.value.replace(/\D+/g, '');

        // Limit to 3 digits max
        if (value.length > 3) {
            value = value.slice(0, 3);
        }

        this.renderer.setProperty(input, 'value', value);
    }

    @HostListener('blur', ['$event'])
    onBlur(event: Event) {
        const input = event.target as HTMLInputElement;
        const rawValue = input.value;

        // If the input is empty, do not enforce any min/max constraints
        if (!rawValue) {
            return;
        }

        let value = parseInt(rawValue, 10);

        if (isNaN(value)) {
            // If no value or invalid, clear it or set a default
            this.renderer.setProperty(input, 'value', '');
            return;
        }

        // Clamp to min/max range
        if (value < this.minHeight) value = this.minHeight;
        if (value > this.maxHeight) value = this.maxHeight;

        this.renderer.setProperty(input, 'value', value.toString());
    }
}
